import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';

import Icon from '../../../components/Icon';

// Cambiar 30 a 1mb

const Wrapper = styled.div<{
  error: boolean;
}>`
  user-select: none;
  margin-bottom: 8px;
  border-radius: 4px;
  overflow: hidden;
`;

const WrapperTop = styled.div<{
  error: boolean;
}>`
  padding: 8px;
  background-color: #eff1f6;

  > p {
    color: #4f6168;
    font-size: 12px;

    > b {
      font-weight: 700;
      color: #161d1f;

      > span {
        color: ${(props) => (props.error ? '#e8212b' : '#161d1f')};
      }
    }
  }
`;

const WrapperBottom = styled.div<{
  error: boolean;
}>`
  padding: 8px;
  display: ${(props) => (props.error ? 'flex' : 'none')};
  align-items: center;
  gap: 8px;
  border-top: 1px solid #cfd4e5;
  background-color: #fddadb;

  > p {
    font-size: 12px;
    color: #ba1821;
  }
`;

interface IProps {
  files: any[];
  maxSizeMegabytes: number;
}

const MemoSize = memo<IProps>(
  ({ files, maxSizeMegabytes }) => {
    const [size, setSize] = useState(0);
    const [error, setError] = useState(false);

    useEffect(() => {
      const count = files.reduce((prev, curr) => prev + curr.size, 0);
      const totalSize = Number(count.toFixed(2));
      setSize(totalSize);
      setError(totalSize > maxSizeMegabytes);
    }, [files]);

    return (
      <Wrapper error={error}>
        <WrapperTop error={error}>
          <p>
            Tamaño total:{' '}
            <b>
              <span>{size} MB</span> / {maxSizeMegabytes} MB
            </b>
          </p>
        </WrapperTop>
        <WrapperBottom error={error}>
          <Icon name="alert-triangle" size={14} color="#ba1821" />
          <p>¡Ups! Tu archivo pesa demasiado. Comprímelo y vuelve a subir.</p>
        </WrapperBottom>
      </Wrapper>
    );
  },
  (prev, next) => {
    if (prev.files === next.files) return true;
    return false;
  }
);

export default MemoSize;
